import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './vendor/amplify';
import './vendor/amplitude';
import './vendor/sentry';
import './vendor/reportWebVitals';
// import { unregister } from './vendor/serviceWorkerRegistration';

createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
// register();
// unregister();
